import { useState } from 'react';

import { AppState } from './useAppState.types';

export const useAppState = () => useState<AppState>('INIT');
